import { Component, Injector, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { SysPesquisaDinamicaService } from 'src/app/services/system/sys-pesquisa-dinamica.service';
import { FormRelatoriosDynamicComponent } from '../formrelatoriosdynamic/formrelatoriosdynamic.component';
import { FormGenerico } from '../formgenerico/formgenerico';
import { SysPesquisaDinamica } from 'src/app/model/system/sysPesquisaDinamica';
import { GlobalFunctions } from '../global-functions';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { Chart, ChartTypeRegistry } from 'chart.js';

@Component({
    selector: 'app-relatorio',
    templateUrl: './formrelatoriosgraficos.component.html',
    styleUrls: ['./formrelatoriosgraficos.component.css']
})
export class FormRelatoriosGraficosComponent extends FormGenerico<SysPesquisaDinamica> implements OnInit {
    grupos: { label: string; value: string }[] = [];
    relatorios: { label: string; value: string; paisagem: string; espacLinhas: number; impLinhas: string; impDetalhe: boolean; impQuebraPag: boolean; geraGrafico: boolean; tipoGrafico: string; colValores: string; colTitulo: string; nomeRelatorio: string; }[] = [];
    parametros: { campo: string; valor: string }[] = [];

    exibirConteudo: boolean = false;
    mostrarTooltip: boolean = false;

    grupoSelecionado: string | null = null;
    relatorioSelecionado: string | null = null;

    exibirGrafico: boolean = false;
    graficoTipo: string = '';
    configuracaoBarra: string = 'vertical';
    graficoColunaValores: string | null = '';
    graficoColunaTitulo: string | null = '';
    tituloRelatorio: string | null = '';
    tituloRelatorioGrafico: string | null = null;
    dadosGrafico: any[] = [];
    labelsGrafico: string[] = [];

    posicaoLegenda: string = 'right';

    imprimirQuebraPag: boolean = false;
    imprimirDetalhes: boolean = false;
    testCheckbox: boolean = false;

    translocoService: TranslocoService;
    globalFunctions: GlobalFunctions;

    itemsFunctions: any[] = [];

    headers: string[] = []; // Cabeçalhos da tabela
    rows: any[] = []; // Dados da tabela
    showTable: boolean = false; // Controle de visibilidade da tabela

    checkboxFields: { key: string; label: string; selected: boolean }[] = [];
    selectedFields: string[] = [];

    subCheckboxFields: { key: string; label: string; selected: boolean }[] = [];
    selectedSubFields: any[] = [];

    orientacoes = [
        { label: 'Paisagem', value: 'Paisagem' },
        { label: 'Retrato', value: 'Retrato' },
    ];
    orientacaoSelecionada: string | null = null;

    opcoesLinhas = [
        { label: 'NÃO', value: 'NÃO' },
        { label: 'SIM', value: 'SIM' },
    ];
    imprimirLinhasSelecionado: string | null = null;

    espacoEntreLinhas: number = 19;

    campoOriginalParaAmigavel: { [original: string]: string } = {};
    campoAmigavelParaOriginal: { [amigavel: string]: string } = {};

    constructor(
        public injector: Injector,
        public api: SysPesquisaDinamicaService,
        public refDialog: DynamicDialogRef,
    ) {
        super(injector, api);
        this.obj = new SysPesquisaDinamica();
        this.globalFunctions = new GlobalFunctions(this.translocoService, this.injector); // Agora pode usar this.injector
    }

    override ngOnInit(): void {
        super.ngOnInit();
        this.loadGrupos();

        this.mostrarTooltip = true;
        setTimeout(() => {
            this.mostrarTooltip = false;
        }, 5000);

        this.itemsFunctions = [
            {
                label: this.translocoService.translate('button_print'),
                icon: 'pi pi-fw pi-print',
                items: [
                    {
                        label: this.translocoService.translate('button_print_graph'),
                        icon: 'pi pi-chart-bar',
                        command: () => {this.printGraph()},
                    },
                    {
                        label: this.translocoService.translate('button_print_Report'),
                        icon: 'pi pi-print',
                        command: () => { this.imprimirRelatorio()},
                    },
                ],
            },
            { label: this.translocoService.translate('button_export'), command: () => { /* this.exportar(); */ } },
            { label: this.translocoService.translate('button_copy_data_to_clipboard'), command: () => { /* this.copiar(); */ } },
        ];
        
    }

    dataExtraObj(res: any) {
        throw new Error('Method not implemented.');
    }

    loadGrupos(): void {
        const idEmpresa = this.auth.empresa.id;
        this.api.findDistinctGrupos(idEmpresa).subscribe(
            (data) => {
                this.grupos = data.map((grupo) => ({ label: grupo, value: grupo }));
                if (this.grupos.length > 0) {
                    this.grupoSelecionado = this.grupos[0].value;
                    this.onGrupoChange();
                }
            },
            (error) => console.error('Erro ao carregar grupos:', error)
        );
    }

    onGrupoChange(): void {
        if (!this.grupoSelecionado) return;

        const idEmpresa = this.auth.empresa.id;
        this.api.findRelatoriosByGrupo(idEmpresa, this.grupoSelecionado).subscribe(
            (data) => {
                this.relatorios = data.map((relatorio) => ({
                    label: `${relatorio.id} - ${relatorio.nome}`,
                    value: relatorio.id.toString(),
                    paisagem: relatorio.relPaisagem === 'SIM' ? 'Paisagem' : 'Retrato',
                    espacLinhas: relatorio.espacLinhas || 19,
                    impLinhas: relatorio.impLinhas || 'NÃO',
                    impDetalhe: relatorio.impDetalhe === 'SIM',
                    impQuebraPag: relatorio.impQuebraPag === 'SIM',
                    geraGrafico: relatorio.geraGrafico === 'SIM',
                    tipoGrafico: relatorio.tipoGrafico || '',
                    colValores: relatorio.colValores || '',
                    colTitulo: relatorio.colTitulo || '',
                    nomeRelatorio: relatorio.nome,
                }));

                if (this.relatorios.length > 0) {
                    this.relatorioSelecionado = this.relatorios[0].value;
                    this.onRelatorioChange();
                } else {
                    this.resetDefaults();
                }
            },
            (error) => console.error('Erro ao carregar relatórios:', error)
        );
    }

    onRelatorioChange(): void {
        const relatorio = this.relatorios.find((r) => r.value === this.relatorioSelecionado);
    
        if (relatorio) {
            this.orientacaoSelecionada = relatorio.paisagem;
            this.espacoEntreLinhas = relatorio.espacLinhas || 19;
            this.imprimirLinhasSelecionado = relatorio.impLinhas || 'NÃO';
            this.imprimirDetalhes = relatorio.impDetalhe === true;
            this.imprimirQuebraPag = relatorio.impQuebraPag === true;
            this.exibirGrafico = relatorio.geraGrafico;
    
            // Usar o método de tradução para inicializar o tipo de gráfico corretamente
            this.graficoTipo = this.getTipoGrafico(relatorio.tipoGrafico); 
            this.graficoColunaValores = relatorio.colValores || null;
            this.graficoColunaTitulo = relatorio.colTitulo || null;
    
            const nomeRelatorio = relatorio.label.split(' - ')[1];
            this.tituloRelatorio = nomeRelatorio;
    
            // Buscar traduções para o relatório selecionado
            this.buscarTraducoesParaRelatorio(this.relatorioSelecionado!);
            // Atualizar o gráfico inicial após carregar os dados
            this.atualizarGrafico();
        } else {
            this.resetDefaults();
        }
    }       

    resetDefaults(): void {
        this.relatorioSelecionado = null;
        this.orientacaoSelecionada = 'Retrato';
        this.espacoEntreLinhas = 19;
        this.imprimirLinhasSelecionado = 'NÃO';
        this.imprimirDetalhes = false;
        this.imprimirQuebraPag = false;
    }

    dynamicRelatorio(fields: { campo: string; tipo: string; valor: any }[]): void {
        const relatorio = this.relatorios.find((r) => r.value === this.relatorioSelecionado);
        const titulo = relatorio ? relatorio.label : 'Relatório Dinâmico';

        const callback = (dadosRecebidos: { empresas: any[]; campos: any[]; resultados?: any[] }) => {
            console.log('Dados recebidos no callback:', dadosRecebidos);

            // Atualizar a lista de empresas em "parametros"
            this.parametros = [
                ...dadosRecebidos.empresas.map((empresa) => ({
                    campo: 'Empresa',
                    valor: empresa.valor,
                })),
                ...dadosRecebidos.campos.map((campo) => ({
                    campo: campo.campo,
                    valor: campo.valor,
                })),
            ];

            // Atualizar os cabeçalhos e dados da tabela se houver resultados
            if (dadosRecebidos.resultados && dadosRecebidos.resultados.length > 0) {
                this.headers = Object.keys(dadosRecebidos.resultados[0]); // Primeira linha define os cabeçalhos
                this.rows = dadosRecebidos.resultados;
                this.showTable = true; // Mostrar a tabela

                // Se a aba de gráfico estiver habilitada, carregar os dados do gráfico
                if (this.exibirGrafico) {
                    this.carregarDadosGrafico(); // Chama a função de carregar e renderizar o gráfico
                }
            } else {
                console.warn('Nenhum resultado encontrado.');
                this.headers = [];
                this.rows = [];
                this.showTable = false; // Ocultar a tabela
            }
        };

        const data = { fields, titulo, callback, relatorioId: relatorio?.value };
        this.showDialogDef(FormRelatoriosDynamicComponent, data, titulo, null, '90%', '90%');
    }

    pesquisar(): void {
        if (!this.relatorioSelecionado) {
            return;
        }

        // Encontra o relatório selecionado e extrai o nome (após o ID no label)
        const relatorioSelecionado = this.relatorios.find(
            (relatorio) => relatorio.value === this.relatorioSelecionado
        );

        if (!relatorioSelecionado) {
            return;
        }

        //const nomeRelatorio = relatorioSelecionado.label.split(' - ')[1] || relatorioSelecionado.label;
        const nomeRelatorio = relatorioSelecionado.label.includes(' - ') && relatorioSelecionado.label.match(/^\d+ - /)
            ? relatorioSelecionado.label.substring(relatorioSelecionado.label.indexOf('-') + 2).trim()
            : relatorioSelecionado.label.trim();

        this.api.extractParametros(nomeRelatorio).subscribe(
            (parametros) => {

                // Pegar o ID da empresa logada
                const idEmpresaAtual = this.auth.empresa.id;
                if (!idEmpresaAtual) {
                    return;
                }

                // Transforme os parâmetros em campos dinâmicos
                const camposDinamicos = parametros.map((param: string) => {
                    if (param.toLowerCase() === 'int_empresa') {
                        return { tipo: 'number', campo: param, valor: idEmpresaAtual };
                    } else if (param.toLowerCase().startsWith('empresa')) {
                        return { tipo: 'empresa', campo: param, valor: '' };
                    } else if (param.toLowerCase().startsWith('data_')) {
                        return { tipo: 'date', campo: param, valor: '' };
                    } else if (param.toLowerCase().startsWith('int_')) {
                        return { tipo: 'number', campo: param, valor: '' };
                    } else {
                        return { tipo: 'text', campo: param, valor: '%' };
                    }
                });

                // Chamar a tela dinâmica passando os campos
                this.dynamicRelatorio(camposDinamicos);
            },
            (error) => {
                console.error("Erro ao buscar parâmetros:", error);
            }
        );
    }

    funcoes(): void {
        console.log('Abrir funções adicionais');
        // Adicione lógica para abrir funções
    }

    imprimirRelatorio(): void {
        const idEmpresa = this.auth.empresa.id;
        const idPesq = Number(this.relatorioSelecionado); // Converte o ID selecionado para número
        const format = 'pdf';
        const landscap = true;
        const loadItems = this.imprimirDetalhes; // Agora depende do checkbox
    
        // Verifique o conteúdo de selectedFields
        console.log("Campos selecionados antes de gerar listaParamsView:", this.selectedFields);
    
        // Criação da listaParamsView com base nos campos selecionados
        const listaParamsView = this.checkboxFields
            .map(field => {
                // Verifica se o campo está marcado (selected: true) ou está presente em selectedFields
                return field.selected || this.selectedFields.includes(field.key) ? '1' : '0';
            })
            .join(';'); // Junta os valores com o separador ';'
    
        // Verifique a listaParamsView gerada
        console.log("ListaParamsView gerada:", listaParamsView);
    
        // Gera o JSON a partir dos parâmetros
        let jsonParaImpressao = this.gerarJSONParaImpressao();
    
        // Removendo campos vazios que não devem ser enviados
        jsonParaImpressao = Object.fromEntries(
            Object.entries(jsonParaImpressao).filter(([_, value]) => value !== "")
        );
    
        // Adiciona a listaParamsView corrigida
        jsonParaImpressao.listaParamsView = listaParamsView;
    
        // Exibe o JSON final
        console.log('JSON para impressão:', jsonParaImpressao);
        console.log('loadItems:', loadItems); // Para depuração
    
        // Envia a requisição para gerar o relatório
        this.api
            .generateDynamicReport(idEmpresa, idPesq, format, landscap, loadItems, jsonParaImpressao)
            .then((response: Blob) => {
                const blob = new Blob([response], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                window.open(url, '_blank');
                setTimeout(() => window.URL.revokeObjectURL(url), 100);
            })
            .catch((error) => {
                console.error('Erro ao gerar o relatório:', error);
            });
    }

    private convertToUnderscore(value: string): string {
        return value.replace(/ /g, '_'); // Substitui espaços por underscores
    }

    gerarJSONParaImpressao(): any {
        const jsonParaImpressao: any = {};

        // Adicionar os parâmetros filtrados
        this.parametrosFiltrados.forEach(param => {
            // Recuperar o nome original a partir do amigável
            const campoOriginal = this.campoAmigavelParaOriginal[param.campo] || this.convertToUnderscore(param.campo);

            // Tratamento especial para "empresa"
            if (campoOriginal.toLowerCase() === 'empresa') {
                jsonParaImpressao['empresas'] = param.valor;
            } else {
                jsonParaImpressao[campoOriginal] = param.valor;
            }
        });

        // Adicionar campos selecionados pelos checkboxes, caso não estejam nos parâmetros filtrados
        const camposSelecionados = this.checkboxFields.filter(field => field.selected);
        camposSelecionados.forEach(field => {
            const campoOriginal = field.key;
            if (!(campoOriginal in jsonParaImpressao)) {
                jsonParaImpressao[campoOriginal] = ''; // Valor pode ser ajustado conforme necessário
            }
        });

        return jsonParaImpressao;
    }

    sair(): void {
        this.refDialog.close(this.obj);
    }

    get parametrosFiltrados(): { campo: string; valor: string }[] {
        return this.parametros.map(parametro => {
            const campoAmigavel = this.gerarNomesAmigaveis(parametro.campo); // Nome amigável gerado dinamicamente
            return { campo: campoAmigavel, valor: parametro.valor };
        });
    }

    isDate(value: any, campo: string = ''): boolean {
        if (campo == 'Empresa' || campo == 'Primeiros' || campo == 'Codigo Conta Pgto') {
            return false; // Nunca formata 'Empresa' ou 'int_Primeiros' como data
        }
        return !isNaN(Date.parse(value)); // Verifica se é uma data válida
    }

    formatDateTime(value: any): string {
        if (!this.isDate(value)) {
            return value;
        }

        const date = new Date(value);

        // Formata a data e hora no padrão desejado (removendo a vírgula)
        const formattedDate = this.globalFunctions.getDataHoraFormat()
            ? new Intl.DateTimeFormat('pt-BR', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: false
            }).format(date).replace(',', '') // Remove a vírgula
            : date.toLocaleString('pt-BR').replace(',', ''); // Como fallback, remove a vírgula também

        return formattedDate.trim(); // Retorna sem espaços extras
    }

    isNumber(value: any): boolean {
        return !isNaN(value) && typeof value === 'number'; // Verifica se é um número
    }

    formatNumber(value: any): string {
        if (!this.isNumber(value)) {
            return value; // Retorna o valor original se não for número
        }
        return this.globalFunctions.getFormatNumber(value); // Usa a função de formatação de número
    }

    gerarNomesAmigaveis(campoOriginal: string): string {
        // Remove prefixo 'int_' e substitui underscores por espaços
        const nomeAmigavel = campoOriginal
            .replace(/^int_/, '') // Remove o prefixo 'int_'
            .replace(/_/g, ' ')   // Substitui underscores por espaços
            .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitaliza as palavras

        // Atualiza os mapeamentos
        this.campoOriginalParaAmigavel[campoOriginal] = nomeAmigavel;
        this.campoAmigavelParaOriginal[nomeAmigavel] = campoOriginal;

        return nomeAmigavel;
    }

    buscarTraducoesParaRelatorio(idRelatorio: string): void {
        const idioma = 'pt_BR'; // Ajuste dinamicamente se necessário
        this.api.getTraducoes(idRelatorio, idioma).subscribe(
            (traducoes) => {
                // Identificar o título (chave sem sufixo `_XX`)
                const tituloRelatorio = traducoes[`sysrel_${idRelatorio}`];
    
                // Separar os itens principais e os itens "sub"
                this.checkboxFields = [];
                this.subCheckboxFields = [];
    
                Object.entries(traducoes).forEach(([key, label]) => {
                    if (key.match(/^sysrel_\d{4}_\d{2}$/)) {
                        // Se for um campo principal (sysrel_XXXX_XX)
                        this.checkboxFields.push({ key, label, selected: true });
                    } else if (key.match(/^sysrel_sub_\d{4}_\d{2}$/)) {
                        // Se for um campo sub (sysrel_sub_XXXX_XX)
                        this.subCheckboxFields.push({ key, label, selected: true });
                    }
                });
    
                // Salvar ou exibir o título, se necessário
                console.log('Título do Relatório:', tituloRelatorio);
            },
            (error) => {
                console.error('Erro ao buscar traduções:', error);
            }
        );
    }

    // Atualize o método carregarDadosGrafico
    carregarDadosGrafico(): void {
        if (!this.graficoColunaValores || this.rows.length === 0) {
            console.warn('Coluna de valores para gráfico não definida ou dados ausentes.');
            return;
        }

        // Atualize o título do gráfico com o título atual do relatório selecionado
        this.tituloRelatorioGrafico = this.tituloRelatorio;

        // Dividir as colunas de valores separadas por ponto e vírgula
        const colunasValores = this.graficoColunaValores.split(';');
        const colunaTitulo = this.graficoColunaTitulo || '';

        // Inicializar arrays
        this.labelsGrafico = [];
        this.dadosGrafico = [];
        const legendTitles: string[] = [];
        const percentages: string[] = [];
        const backgroundColors: string[] = [];

        // Processar cada coluna de valores
        colunasValores.forEach((coluna) => {
            // Filtrar linhas válidas
            const validRows = this.rows.filter((row) =>
                row[coluna] != null && (colunaTitulo === '' || row[colunaTitulo] != null)
            );

            // Capturar labels e dados para a coluna
            if (this.labelsGrafico.length === 0) {
                this.labelsGrafico = validRows.map((row) => row[this.headers[0]]);
            }
            const dados = validRows.map((row) => row[coluna]);
            this.dadosGrafico = this.dadosGrafico.concat(dados);

            // Adicionar títulos das legendas
            legendTitles.push(
                ...validRows.map((row) =>
                    colunaTitulo ? row[colunaTitulo] || 'Sem Título' : 'Sem Título'
                )
            );

            // Calcular total e percentuais
            const total = dados.reduce((sum, value) => sum + value, 0);
            percentages.push(
                ...dados.map((value) => (total > 0 ? ((value / total) * 100).toFixed(2) : '0.00'))
            );

            // Gerar cores únicas
            backgroundColors.push(...dados.map(() => this.generateRandomColor()));
        });

        // Criar um único dataset com todos os dados
        const datasets = [
            {
                label: this.graficoColunaValores,
                data: this.dadosGrafico,
                backgroundColor: backgroundColors,
                borderColor: backgroundColors.map((color) => color.replace('0.6', '1')),
                borderWidth: 1,
            },
        ];

        // Renderizar o gráfico
        this.renderizarGrafico(datasets, legendTitles, percentages);
    }

    renderizarGrafico(datasets: any[], legendTitles: string[], percentages: string[]): void {
        const ctx = document.getElementById('graficoCanvas') as HTMLCanvasElement;
    
        if (!ctx) {
            console.error('Elemento canvas não encontrado para renderizar o gráfico.');
            return;
        }
    
        // Destruir gráfico existente, se houver
        if (Chart.getChart(ctx)) {
            Chart.getChart(ctx)?.destroy();
        }
    
        new Chart(ctx, {
            type: this.getTipoGrafico(this.graficoTipo),
            data: {
                labels: this.labelsGrafico,
                datasets: datasets.map((dataset) => ({
                    label: dataset.label,
                    data: dataset.data,
                    backgroundColor: dataset.backgroundColor,
                    borderColor: dataset.borderColor,
                    borderWidth: dataset.borderWidth,
                })),
            },
            options: {
                responsive: true, // Torna o gráfico responsivo
                maintainAspectRatio: false, // Permite controle independente de largura e altura
                plugins: {
                    legend: {
                        display: true,
                        position: 'right',
                        labels: {
                            generateLabels: (chart) => {
                                return chart.data.labels?.map((label, index) => {
                                    const title = legendTitles[index] || 'Sem Título';
                                    const value = datasets[0].data[index];
                                    const percentage = percentages[index];
                                    return {
                                        text: `${title}: ${value?.toLocaleString(
                                            'pt-BR',
                                            { style: 'currency', currency: 'BRL' }
                                        ) || '0,00'} (${percentage}%)`,
                                        fillStyle: datasets[0].backgroundColor[index],
                                        hidden: false,
                                        lineCap: 'round',
                                        lineJoin: 'round',
                                        strokeStyle: datasets[0].backgroundColor[index],
                                        pointStyle: 'rect',
                                    };
                                }) || [];
                            },
                        },
                    },
                    tooltip: {
                        callbacks: {
                            label: (context) => {
                                const value = context.raw as number;
                                const percentage = percentages[context.dataIndex];
                                const legendTitle = legendTitles[context.dataIndex] || 'Sem Título';
                                return `${legendTitle}: ${value?.toLocaleString(
                                    'pt-BR',
                                    { style: 'currency', currency: 'BRL' }
                                ) || '0,00'} (${percentage}%)`;
                            },
                        },
                    },
                },
                scales: {
                    x: {
                        beginAtZero: true,
                    },
                    y: {
                        beginAtZero: true,
                    },
                },
            },
        });
    }    

    getTipoGrafico(tipo: string | undefined): keyof ChartTypeRegistry {
        if (!tipo) {
            return 'pie';
        }
    
        // Mapeamento explícito para valores do dropdown
        const tipoMapeado = {
            BARRA: 'bar',
            PIZZA: 'pie',
            LINHA: 'line',
            ROSQUINHA: 'doughnut',
            'ÁREA POLAR': 'polarArea',
            RADAR: 'radar',
        };
    
        // Se o tipo já for aceito pelo Chart.js, retorna diretamente
        if (Object.values(tipoMapeado).includes(tipo.toLowerCase())) {
            return tipo.toLowerCase() as keyof ChartTypeRegistry;
        }
    
        // Caso contrário, tenta mapear do dropdown
        const tipoGrafico = tipoMapeado[tipo.toUpperCase()];
        if (!tipoGrafico) {
            return 'pie';
        }
    
        return tipoGrafico as keyof ChartTypeRegistry;
    }       

    generateRandomColor(): string {
        const r = Math.floor(Math.random() * 255);
        const g = Math.floor(Math.random() * 255);
        const b = Math.floor(Math.random() * 255);
        return `rgba(${r}, ${g}, ${b}, 0.6)`; // Cor semi-transparente
    }

    getRandomColor(): string {
        const letters = '0123456789ABCDEF';
        let color = '#';
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    }

    // Para ajustar a luminosidade de uma cor (sombras)
    shadeColor(color: string, percent: number): string {
        let R = parseInt(color.substring(1, 3), 16);
        let G = parseInt(color.substring(3, 5), 16);
        let B = parseInt(color.substring(5, 7), 16);

        R = Math.min(255, Math.max(0, R + (R * percent) / 100));
        G = Math.min(255, Math.max(0, G + (G * percent) / 100));
        B = Math.min(255, Math.max(0, B + (B * percent) / 100));

        return `rgb(${R},${G},${B})`;
    }

    // Método para atualizar a posição da legenda
    alterarPosicaoLegenda(event: Event): void {
        const selectElement = event.target as HTMLSelectElement | null;
        if (selectElement) {
            this.posicaoLegenda = selectElement.value as 'top' | 'left' | 'bottom' | 'right';
            this.atualizarGrafico(); // Atualiza o gráfico com a nova posição
        } else {
            console.error('Elemento select não encontrado.');
        }
    }
    

    // Método para atualizar a posição da legenda sem recriar o gráfico
    atualizarGrafico(): void {
        const ctx = document.getElementById('graficoCanvas') as HTMLCanvasElement;
        if (!ctx) {
            console.error('Elemento canvas não encontrado para renderizar o gráfico.');
            return;
        }
    
        // Destruir gráfico existente
        if (Chart.getChart(ctx)) {
            Chart.getChart(ctx)?.destroy();
        }
    
        // Configurações para barras específicas
        const isBarOrLine = this.graficoTipo === 'bar' || this.graficoTipo === 'line';
        const indexAxis: "x" | "y" | undefined = this.configuracaoBarra === 'horizontal' ? 'y' : 'x'; // Ajustar o tipo corretamente
    
        const options = {
            responsive: true,
            plugins: {
                legend: {
                    display: true,
                    position: this.posicaoLegenda as 'top' | 'left' | 'bottom' | 'right',
                    labels: {
                        boxWidth: 20, // Largura do box de cor
                        padding: 15, // Espaçamento entre os itens
                        generateLabels: (chart) => {
                            // Customizando as legendas para manter consistência
                            return chart.data.labels?.map((label, index) => ({
                                text: `${label}: ${chart.data.datasets[0].data[index]?.toLocaleString(
                                    'pt-BR',
                                    { style: 'currency', currency: 'BRL' }
                                ) || ''}`,
                                fillStyle: chart.data.datasets[0].backgroundColor[index],
                                hidden: false,
                            })) || [];
                        },
                    },
                },
                tooltip: {
                    callbacks: {
                        label: (context) => {
                            const value = context.raw as number;
                            return `Quantidade: ${value?.toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                            })}`;
                        },
                    },
                },
            },
            indexAxis: isBarOrLine ? indexAxis : 'x', // Configura eixo para gráficos de barra ou linha
            scales: isBarOrLine
                ? {
                      x: {
                          stacked: this.configuracaoBarra === 'stacked', // Ativa empilhamento
                      },
                      y: {
                          stacked: this.configuracaoBarra === 'stacked', // Ativa empilhamento
                      },
                  }
                : undefined, // Outras configurações específicas para tipos não "bar" ou "line"
        };
    
        // Recriar o gráfico com o tipo e configurações atualizadas
        new Chart(ctx, {
            type: this.graficoTipo as keyof ChartTypeRegistry,
            data: {
                labels: this.labelsGrafico,
                datasets: [
                    {
                        label: this.graficoColunaValores || 'Sem título',
                        data: this.dadosGrafico,
                        backgroundColor: this.dadosGrafico.map(() => this.generateRandomColor()),
                    },
                ],
            },
            options,
        });
    }  

    opcoesLegenda = [
        { label: 'Topo', value: 'top' },
        { label: 'Esquerda', value: 'left' },
        { label: 'Inferior', value: 'bottom' },
        { label: 'Direita', value: 'right' },
    ];  
    
    opcoesTipoGrafico = [
        { label: 'BARRA', value: 'bar' },
        { label: 'PIZZA', value: 'pie' },
        { label: 'LINHA', value: 'line' },
        { label: 'ROSCA', value: 'doughnut' },
        { label: 'ÁREA POLAR', value: 'polarArea' },
        { label: 'RADAR', value: 'radar' },
    ];
    
    opcoesTipoBarra = [
        { label: 'Vertical', value: 'vertical' },
        { label: 'Horizontal', value: 'horizontal' },
        { label: 'Multi Eixos', value: 'multiAxis' },
        { label: 'Empilhado', value: 'stacked' },
    ];   

    printGraph(): void {
        const canvas = document.getElementById('graficoCanvas') as HTMLCanvasElement;
    
        if (!canvas) {
            console.error('Canvas do gráfico não encontrado!');
            return;
        }
    
        // Captura a imagem do gráfico como base64
        const imageURL = canvas.toDataURL('image/png');
    
        // Cria um novo HTML para exibir apenas o título e o gráfico
        const titulo = this.tituloRelatorioGrafico || 'Gráfico';
        const printWindow = window.open('', '_blank');
        if (printWindow) {
            printWindow.document.write(`
                <html>
                    <head>
                        <title>Impressão do Gráfico</title>
                        <style>
                            body {
                                margin: 0;
                                padding: 0;
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                justify-content: center;
                                height: 100vh; /* Ocupa a altura total da página */
                                width: 100vw; /* Ocupa a largura total da página */
                                font-family: Arial, sans-serif;
                            }
                            h1 {
                                text-align: center;
                                font-size: 28px; /* Tamanho maior do título */
                                margin-bottom: 20px;
                            }
                            img {
                                width: 100%; /* Faz o gráfico ocupar 90% da largura da folha */
                                height: auto;
                                max-height: 90vh; /* Garante que não ultrapasse 80% da altura */
                                display: block;
                            }
                        </style>
                    </head>
                    <body>
                        <h1>${titulo}</h1>
                        <img src="${imageURL}" alt="Gráfico" />
                    </body>
                </html>
            `);
    
            // Aguarde até que o conteúdo seja carregado antes de imprimir
            printWindow.document.close();
            printWindow.onload = () => {
                printWindow.print();
                printWindow.onafterprint = () => printWindow.close();
            };
        } else {
            console.error('Não foi possível abrir uma nova aba para impressão.');
        }
    }             

    protected onPropertyChange(propName: string, newValue: any): void {}
}
